import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { isConfigFlagEnabled } from '../../config';
import { DiscordButton } from '../discordButton';
import { OpenModalContainer } from '../openModalContainer';
import { BlueskyButton } from '../socialMedia/blueskyButton';
export const CommunityModal = ({ onClose }) => {
    return (_jsx(OpenModalContainer, { title: 'Community / Support', onClose: onClose, maxWidth: 'md', children: _jsxs(DialogContent, { children: [_jsx(DialogContentText, { component: 'div', children: "Connect with the community and get support on other platforms!" }), _jsx(DialogActions, { children: _jsx(BlueskyButton, { size: 'large' }) }), isConfigFlagEnabled('showDiscordButton') && (_jsx(DialogActions, { children: _jsx(DiscordButton, { size: 'large', label: 'Triplejack Discord Server' }) }))] }) }));
};
